import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStore, faCartShopping } from '@fortawesome/free-solid-svg-icons';
import { cn } from '../../../../ui/utils/cn';

// where the coffee came from. 'supermarket' is a packaged/branded coffee (no shop,
// no sugar/milk format) that bypasses the location-first GPS gate; everything else
// (café visits + home-made) lives under 'shop'.
export type CoffeeEntryMode = 'shop' | 'supermarket';

interface ModeSelectorProps {
    mode: CoffeeEntryMode;
    onChange: (mode: CoffeeEntryMode) => void;
    disabled?: boolean;
}

const OPTIONS: { value: CoffeeEntryMode; label: string; icon: typeof faStore }[] = [
    { value: 'shop', label: 'Café / Shop', icon: faStore },
    { value: 'supermarket', label: 'Supermarket', icon: faCartShopping },
];

const ModeSelector: React.FC<ModeSelectorProps> = ({ mode, onChange, disabled = false }) => (
    <div className="flex gap-2">
        {OPTIONS.map((opt) => (
            <button
                key={opt.value}
                type="button"
                disabled={disabled}
                onClick={() => onChange(opt.value)}
                className={cn(
                    'flex-1 flex items-center justify-center gap-2 py-2.5 px-3 rounded-xl text-sm font-medium transition-all border-2',
                    mode === opt.value
                        ? 'border-mint bg-mint/10 text-foreground shadow-sm'
                        : 'border-gray-200 bg-white text-gray-500 hover:border-gray-300',
                    disabled && 'opacity-60 cursor-not-allowed',
                )}
            >
                <FontAwesomeIcon icon={opt.icon} className="h-3.5 w-3.5" />
                <span>{opt.label}</span>
            </button>
        ))}
    </div>
);

export default ModeSelector;
